import NoData from "components/Errors/NoData";

const Settings = () => {
  return (
    <div>
      <h4>Settings</h4>
      <NoData />
    </div>
  );
};

export default Settings;
